import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home.vue'
import EntryMail from '@/components/EntryMail.vue'
import MailConfirm from '@/components/MailConfirm.vue'
import Entry from '@/components/Entry.vue'
import EntryStep1 from '@/components/EntryStep1.vue'
import EntryStep2 from '@/components/EntryStep2.vue'
import EntryStep3 from '@/components/EntryStep3.vue'
import EntryConfirm from '@/components/EntryConfirm.vue'
import EntryResult from '@/components/EntryResult.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/mailconfirm',
    name: 'MailConfirmEmpty',
    component: MailConfirm,
    props: { token: '' }
  },
  {
    path: '/mailconfirm/:token',
    name: 'MailConfirm',
    component: MailConfirm,
    props: true
  },
  {
    path: '/entry',
    name: 'Entry',
    component: Entry,
    children: [
      {
        path: 'mail',
        name: 'EntryMail',
        component: EntryMail
      },
      {
        path: 'step1',
        name: 'EntryStep1',
        component: EntryStep1
      },
      {
        path: 'step2',
        name: 'EntryStep2',
        component: EntryStep2
      },
      {
        path: 'step3',
        name: 'EntryStep3',
        component: EntryStep3
      },
      {
        path: 'confirm',
        name: 'EntryConfirm',
        component: EntryConfirm
      },
      {
        path: 'result',
        name: 'EntryResult',
        component: EntryResult
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router
